<template>
  <div class="container">
    <v-content>
      <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm8
            md4
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>Register</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <span>Source</span>
                </v-tooltip>
                <v-tooltip right>
                  <span>Codepen</span>
                </v-tooltip>
              </v-toolbar>
              <v-alert v-if="error" type="error">{{error}}</v-alert>
              <v-card-text>
                <v-form action="#" @submit.prevent="submit">
                  <v-text-field
                    label="Name"
                    id="name"
                    name="name"
                    prepend-icon="mdi-card-account-details"
                    type="name"
                    class="form-control"
                    value
                    required
                    autofocus
                    v-model="form.name"
                  ></v-text-field>

                  <v-text-field
                    label="E-Mail"
                    id="email"
                    type="email"
                    name="email"
                    prepend-icon="mdi-account"
                    class="form-control"
                    value
                    required
                    autofocus
                    v-model="form.email"
                  ></v-text-field>
                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    required
                    v-model="form.password"
                  ></v-text-field>

                  <v-text-field
                    label="Permission"
                    id="permission"
                    name="permission"
                    prepend-icon="mdi-card-account-details"
                    type="permission"
                    class="form-control"
                    value
                    required
                    autofocus
                    v-model="form.permission"
                  ></v-text-field>

                  <!--
                  <v-select
                    :items="['Admin', 'School Admin', 'Teacher', 'Student']"
                    :value="selected"
                    label="Outlined style"
                    required
                    outlined
                    v-model="form.permission"
                  ></v-select>
                  -->
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" type="submit">Register</v-btn>
                  </v-card-actions>

                </v-form>
              </v-card-text>

            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </div>
</template>


<script>
import firebase from "firebase";

export default {
  data() {
    return {
      form: {
        name: "",
        permission: "",
        email: "",
        password: ""
      },
      error: null
    };
  },
  methods: {
    submit() {
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.form.email, this.form.password)
        .then(data => {
          data.user
            .updateProfile({
              displayName: this.form.name,
              permission: this.form.permission
            })
            .then(() => {
              this.$router.replace({ name: "Dashboard" });
            });
        })
        .catch(err => {
          this.error = err.message;
        });
    }
  }
};
</script>
